import getESTDate from './getESTDate';
/**
 * Returns the corresponding hour in EST
 *
 * @param {Date} today Date from where to calculate EST hour
 * @returns {Int} Hour in EST
 */
function getESTHour(today) {
  const estDate = getESTDate(today);
  const hour = estDate.getHours();

  return hour;
}

export default getESTHour;
